/** "$1,234.50" from integer cents (null → "unlimited" or a custom word). */
export function usd(cents: number | null, none = "unlimited"): string {
  if (cents === null) return none;
  const whole = Math.trunc(cents / 100)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return `$${whole}.${String(Math.abs(cents % 100)).padStart(2, "0")}`;
}

/** Integer cents → the dollar string the API accepts ("12.5" → "12.50"). */
export function centsToInput(cents: number | null): string {
  if (cents === null) return "";
  return `${Math.trunc(cents / 100)}${cents % 100 ? `.${String(cents % 100).padStart(2, "0")}` : ""}`;
}

/** "" → null, otherwise the trimmed dollar string. */
export function inputToDollars(value: string): string | null {
  const v = value.trim().replace(/[$,]/g, "");
  return v === "" ? null : v;
}

export const DOLLARS = /^\d{1,9}(\.\d{1,2})?$/;
